import {
  Component,
  ViewChild,
  OnInit,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatSnackBar } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { FormDoc } from "src/app/core/models/physician/form-doc";
import { FormDocBuilder } from "src/app/core/models/physician/form-doc-builder";
import { FormServiceResolver } from "src/app/core/services/v2/form.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
declare const WebViewer: any;
@Component({
  selector: "form-acroformdesign",
  templateUrl: "./form-acroformdesign.component.html",
  styleUrls: ["./form-acroformdesign.component.scss"],
})
export class FormAcroformdesignComponent implements OnInit, AfterViewInit {
  // Syntax if using Angular 8+
  // true or false depending on code
  @ViewChild("viewer", { static: false }) viewer: ElementRef;
  @ViewChild("fileupload", { static: false }) fileupload: ElementRef;

  wvInstance: any;
  signedblob: Blob;
  formDocument: FormDoc;
  formBuilder: FormDocBuilder;
  errorMessage: string;
  id: number;
  sectionName: string;
  toggleSidebar = false;

  sideBarHeader: string = "Add to Folder";

  codeFormControl = new FormControl("", [Validators.required]);
  titleFormControl = new FormControl("", [Validators.required]);
  summaryFormControl = new FormControl("", []);
  constructor(
    private _formServiceResolver: FormServiceResolver,
    private _route: ActivatedRoute,
    private _router: Router,
    private _loaderService: WindowLoaderService,
    private _dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {}
  setSidebarHeader() {
    switch (this.sectionName) {
      case "managefolders":
        this.sideBarHeader = "Folders";
        break;
      case "addtofolders":
        this.sideBarHeader = "Add to Folder";
        break;
    }
  }

  formDocForm: FormGroup = new FormGroup({
    code: this.codeFormControl,
    title: this.titleFormControl,
    summary: this.summaryFormControl,
  });

  ngOnInit() {
    //this.wvDocumentLoadedHandler = this.wvDocumentLoadedHandler.bind(this);
  }

  ngAfterViewInit(): void {
    // The following code initiates a new instance of WebViewer.

    WebViewer(
      {
        disabledElements: [
          //'ribbons',
          "toggleNotesButton",
          "searchButton",
          //'menuButton',
          "rubberStampToolGroupButton",
          "stampToolGroupButton",
          "fileAttachmentToolGroupButton",
          "calloutToolGroupButton",
          //'undo',
          //'redo',
          //'eraserToolButton'
        ],
        path: "../../wv-resources/lib",
        // initialDoc: './assets/pdf/AH-SaaS Agreement - March 2021 v3.pdf'
      },
      this.viewer.nativeElement
    ).then((instance) => {
      this.fileupload.nativeElement.addEventListener("change", () => {
        // Get the file from the input
        const file = this.fileupload.nativeElement.files[0];
        instance.UI.loadDocument(file, { filename: file.name });
      });
      this.wvInstance = instance;
      const { documentViewer, annotationManager, Annotations } = instance.Core;
      const { WidgetFlags } = Annotations;
      const { Feature } = instance.UI;
      instance.UI.enableFeatures([Feature.FilePicker]);
      instance.UI.disableElements(["toolbarGroup-Annotate"]);
      instance.UI.disableElements(["toolbarGroup-Shapes"]);
      instance.UI.disableElements(["toolbarGroup-Edit"]);
      instance.UI.disableElements(["toolbarGroup-Insert"]);
      //instance.UI.disableElements(['toolbarGroup-Insert']);

      instance.UI.disableElements(["toolbarGroup-FillAndSign"]);

      // remove left panel and left panel button from the DOM
      instance.UI.disableElements(["leftPanel", "leftPanelButton"]);

      // now you can access APIs through this.webviewer.getInstance()
      //instance.UI.openElement('notesPanel');
      // see https://www.pdftron.com/documentation/web/guides/ui/apis
      // for the full list of APIs

      // or listen to events from the viewer element
      this.viewer.nativeElement.addEventListener("pageChanged", (e) => {
        const [pageNumber] = e.detail;
        console.log(`Current page is ${pageNumber}`);
      });

      const normalStyles = (widget) => {
        if (widget instanceof Annotations.TextWidgetAnnotation) {
          return {
            "background-color": "#a5c7ff",
            color: "white",
          };
        } else if (widget instanceof Annotations.SignatureWidgetAnnotation) {
          return {
            border: "1px solid #a5c7ff",
          };
        }
      };

      annotationManager.addEventListener(
        "annotationChanged",
        async (annotations, action, { imported }) => {
          documentViewer.getAnnotationsLoadedPromise().then(() => {
            const fieldManager = annotationManager.getFieldManager();
            var allfields = fieldManager.getFields();
          });
          if (action === "add") {
            const doc = documentViewer.getDocument();
            const xfdfString = await annotationManager.exportAnnotations();
            const options = { xfdfString };
            const data = await doc.getFileData(options);
            const arr = new Uint8Array(data);
            this.signedblob = new Blob([arr], { type: "application/pdf" });
            // upload blob to your server
            annotations.forEach(function (annot) {
              if (annot instanceof Annotations.WidgetAnnotation) {
                Annotations.WidgetAnnotation.getCustomStyles = normalStyles;
                // if (!annot.fieldName.startsWith(email)) {
                //   annot.Hidden = true;
                //   annot.Listable = false;
                // }
              }
            });
          }
        }
      );
      documentViewer.addEventListener("documentLoaded", () => {
        documentViewer.getAnnotationsLoadedPromise().then(() => {
          const fieldManager = annotationManager.getFieldManager();
          const txt_ClientNamefield = fieldManager.getField("txt_ClientName");
          const txt_Line1Field = fieldManager.getField("txt_Line1");
          const txt_Line2Field = fieldManager.getField("txt_Line2");
          const txt_CityField = fieldManager.getField("txt_City");
          const txt_StateField = fieldManager.getField("txt_State");
          const txt_ZipField = fieldManager.getField("txt_Zip");
          const txt_PhoneField = fieldManager.getField("txt_Phone");
          const txt_FaxField = fieldManager.getField("txt_Fax");
          const txt_EmailField = fieldManager.getField("txt_Email");
          const txt_GlobalAdministratorField = fieldManager.getField(
            "txt_GlobalAdministrator"
          );
          //Set value
          txt_ClientNamefield.setValue("Client Name");
          const fieldManager1 = annotationManager.getFieldManager();
          var allfields1 = fieldManager1.getFields();
          console.log(allfields1);
        });
      });
    });
  }
  onSubmit() {
    console.log("submit");
    var f = new File([this.signedblob], "fileName.pdf", {
      lastModified: new Date().getTime(),
      type: this.signedblob.type,
    });
    var url = window.URL.createObjectURL(this.signedblob);
    window.open(url);
    console.log(f);
  }
}
